export enum IdpFormMode {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
}
